import { z } from 'zod';

export const DeactivateProfileTemplateResponseSchema = z.object({
  id: z.uuid(),
  active: z.literal(false),
});

export type DeactivateProfileTemplateResponse = z.infer<
  typeof DeactivateProfileTemplateResponseSchema
>;
